export default __webpack_public_path__ + "static/media/spotify-logo-round.7000afed.png";